import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { MODAL_CONTENT } from '../Modal/creditCard/addCreditCard';

const StepsIndicator = ({ currentStep }) => {
  return (
    <ul className="progressbar mt-2">
      {MODAL_CONTENT.map(({ name }, index) => {
        const isActive = currentStep === index;
        const isCompleted = currentStep > index;

        return (
          <li className={isActive && 'active'}>
            <div className="step">
              {isCompleted ? <FontAwesomeIcon icon="check" /> : index + 1}
            </div>
            <p className={!isActive && 'text-muted'}>{name}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default StepsIndicator;



// WEBPACK FOOTER //
// ./src/components/creditCard/stepsIndicator.js